var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowRisk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.797 2.805c.005-.275-.103-.54-.299-.735-.195-.194-.461-.3-.737-.294-.272-.004-.535.104-.725.298-.19.195-.293.46-.283.732v2.188c0 .041-.025.078-.063.094s-.082.007-.111-.021L1.647.214C1.418-.015.877-.176.341.361c-.395.326-.456.908-.136 1.309l4.86 4.905c.03.029.038.073.022.11-.016.039-.053.064-.094.064H2.727c-.565 0-1.023.458-1.023 1.023s.458 1.022 1.023 1.022h5.661c.226 0 .41-.183.41-.409v-5.58z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowRisk);
export default __webpack_public_path__ + "static/media/low-risk.93d18f18b2e8c36f655ca31685fa0b1f.svg";
export { ForwardRef as ReactComponent };